const pageMixin = {
  data() {
    return {
      page: {
        tot: 25,
        cur: 1,
        per: 25,
      },
    }
  },
}

export { pageMixin }
